import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '../../css';
import {
  Backdrop,
  Content,
  Button,
  Heading,
  FixedContent,
  ChildrenContent
} from './css';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const ModalCustom = ({
  open,
  setOpen,
  header,
  children,
  customStyles,
  hideCloseButton
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    MODAL: { BUTTON_CLOSE }
  } = localizedStrings;

  return (
    open && (
      <Backdrop>
        <Content customStyles={customStyles}>
          <FixedContent>
            <Box width={80}>
              <Heading>{header}</Heading>
            </Box>
            {hideCloseButton ? null : (
              <Box
                width={20}
                display="flex"
                justifyContent="flex-end"
                flexDirection="row"
              >
                <Button popupHeader onClick={() => setOpen()}>
                  {BUTTON_CLOSE}
                </Button>
              </Box>
            )}
          </FixedContent>
          <ChildrenContent>{children}</ChildrenContent>
        </Content>
      </Backdrop>
    )
  );
};

ModalCustom.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  header: PropTypes.string,
  children: PropTypes.node.isRequired,
  customStyles: PropTypes.objectOf(PropTypes.object),
  hideCloseButton: PropTypes.bool
};

ModalCustom.defaultProps = {
  open: false,
  header: '',
  customStyles: null,
  hideCloseButton: false
};
export default ModalCustom;
